import React from 'react';
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { ArrowForwardRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const _IncreaseHistoryHeader = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'flex-start', sm: 'center' },
                justifyContent: 'space-between',
                gap: 2,
                mb: 3.5
            }}
        >
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.8 }}>
                    <Tooltip title="بازگشت به بخش مالی">
                        <IconButton
                            onClick={() => navigate("/charge")}
                            sx={{
                                bgcolor: 'background.paper',
                                border: '1px solid',
                                borderColor: 'divider',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                '&:hover': { bgcolor: 'action.hover' }
                            }}
                        >
                            <ArrowForwardRounded fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 900,
                            color: 'text.primary',
                            fontSize: { xs: '1.4rem', sm: '1.75rem' },
                            letterSpacing: -0.5
                        }}
                    >
                        تاریخچه واریزها و تراکنش‌های مالی
                    </Typography>
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary', mr: { sm: 6 } }}>
                    سوابق واریزها و فاکتورهای حساب
                </Typography>
            </Box>
        </Box>
    );
};

export default _IncreaseHistoryHeader;
